/**
 * FILE: apps/hub/src/lib/modalStack.ts
 * PURPOSE: LIFO stack of modal/panel close handlers for global Esc handling.
 * AGENT_CONTEXT: Keyboard shortcuts — top of stack closes first.
 */

const closers: Array<() => void> = []

export function pushModalCloser(close: () => void): () => void {
  closers.push(close)
  return () => {
    const i = closers.lastIndexOf(close)
    if (i >= 0) closers.splice(i, 1)
  }
}

export function closeTopModal(): boolean {
  const fn = closers.pop()
  if (fn) {
    fn()
    return true
  }
  return false
}

export function modalStackDepth(): number {
  return closers.length
}
